export default class UserModel {
    public Token: string
    public UserName: string
    public NombreCompleto: string
}